import React from 'react'
import Select from 'react-select'
import { isEqual } from 'lodash'
import SetsAddCompForm from '../settings/SetsAddCompForm'
import { fnum, sortOpts } from '../../utils/utils'
import Form from '../ui/Form'

export default class PRSAddPostForm extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      showCreateComp: false,
      errors: {}
    };
  }

  savePost = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(this.props.data, data)) {
      this.props.cancelAdd();
    }
    else {
      this.props.editPost(data, (err, id) => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        if (data.cost_price*data.cost_qntt > 0) {
          const newCost = {
            ...data,
            post_payer: data.post_seller,
            post_seller: data.cost_seller,
            post_price: data.cost_price,
            post_qntt: data.cost_qntt,
            post_link: id
          };
          this.props.editPost(newCost, () => {
            this.props.cancelAdd();
            const diffP = data.post_price * data.post_qntt;
            const diffC = data.cost_price * data.cost_qntt;
            this.props.updtBlnc(diffP, diffP, diffC);
          });
        }
        else {
          this.props.cancelAdd();
          const diffP = data.post_price * data.post_qntt;
          this.props.updtBlnc(diffP, diffP, 0);
        }
      });
    }
  }

  updateSrvc = e => {
    const desc = this.state.data.post_desc === "" ?
      (this.props.srvcs[e.value].srvc_longdesc.length > 0 ?
        this.props.srvcs[e.value].srvc_longdesc
        : this.props.srvcs[e.value].srvc_desc
      )
      : this.state.data.post_desc;
    this.setState({
      data:{
        ...this.state.data,
        post_srvc_id:e.value,
        post_srvg_id:this.props.srvcs[e.value].srvc_srvg_id,
        post_price:this.props.srvcs[e.value].srvc_price,
        cost_price:this.props.srvcs[e.value].srvc_cost,
        post_desc:desc
      }
    });
  }

  showCreateComp = () => {
    this.setState({
      showCreateComp:true
    });
  }

  hideCreateComp = () => {
    this.setState({
      showCreateComp:false
    });
  }

  selectAddedComp = id => {
    this.setState({
      data:{
        ...this.state.data,
        cost_seller: id
      }
    });
  }

  render() {
    const { srvcs, srvgs, ctypes, comps } = this.props;

    const { data, errors } = this.state;

    const showCreateComp = this.state.showCreateComp ?
      <SetsAddCompForm
        afterSave={this.selectAddedComp}
        addSets={this.props.addSets}
        onCancel={this.hideCreateComp}
        srvgs={srvgs}
        ctypes={ctypes}
        data={{
          comp_desc: '',
          comp_long: '',
          comp_city: '',
          comp_addr: '',
          comp_tel: '',
          comp_email: '',
          comp_note: '',
          comp_own: 0,
          comp_order: 0,
          comp_expense: 0,
          comp_cost: 1,
          comp_empl: 0,
          comp_ctype_id: 0,
          comp_srvg_ids: '',
          comp_active: 1
        }}
      />
      : '';

    const srvcsOpt = [];
    for (let key in srvcs){
      if(
        srvcs.hasOwnProperty(key) &&
        srvcs[key].srvc_active === 1 &&
        srvcs[key].srvc_type === 1 &&
        srvcs[key].srvc_post === 1
      ){
        srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    srvcsOpt.sort(sortOpts);
    const srvgsOpt = [];
    for (let key in srvgs){
      if(srvgs.hasOwnProperty(key) && srvgs[key].srvg_active === 1 &&
        srvgs[key].srvg_prs === 1){
        srvgsOpt.push({value:srvgs[key].srvg_id,label:srvgs[key].srvg_desc});
      }
    }
    srvgsOpt.sort(sortOpts);
    const compsOpt = [];
    for (let key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active === 1
        && comps[key].comp_cost === 1) {
        compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
      }
    }
    compsOpt.sort(sortOpts);

    return (
      <tr>
        <td>
          {showCreateComp}
          <div className="form-group">
            <button  type="button" className="btn btn-success btn-xs"
              onClick={this.savePost}
              title="Сохранить"
            >
              <span className="glyphicon glyphicon-save"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-default btn-xs"
              onClick={this.props.cancelAdd}
              title="Отменить"
            >
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control text-editable"
              value={data.post_sort}
              name="post_sort"
              onChange={this.updateInput}
              title="Номер по порядку"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Услуга</label>&nbsp;
              <div style={{flex: 1, width: 0}}>
                <Select
                  clearable={false}
                  options={srvcsOpt}
                  value={data.post_srvc_id}
                  onChange={this.updateSrvc}
                  autofocus
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              name="post_desc"
              value={data.post_desc}
              rows="3"
              title="Описание"
              placeholder="Описание"
              onChange={this.updateInput}
            />
          </div>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Группа</label>&nbsp;
              <div style={{flex: 1, width: 0}}>
                <Select
                  clearable={false}
                  options={srvgsOpt}
                  value={data.post_srvg_id}
                  onChange={e => this.updateSelect(e,'post_srvg_id')}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Подрядчик</label>&nbsp;
              <div style={{flex: 1, width: 0}}>
                <Select
                  clearable={false}
                  options={compsOpt}
                  value={data.cost_seller}
                  onChange={e => this.updateSelect(e,'cost_seller')}
                />
              </div>&nbsp;
              <button type="button" className="btn btn-default"
                onClick={this.showCreateComp}
                title="Создать подрядчика"
              >
                <span className="glyphicon glyphicon-plus"></span>
              </button>
            </div>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control text-editable"
              value={data.post_price}
              name="post_price"
              onChange={this.updateInput}
            />
          </div>
          <div className="form-group">
            <input type="text"
              className="form-control text-editable text-editable__blue"
              value={data.cost_price}
              name="cost_price"
              onChange={this.updateInput}
            />
          </div>
        </td>
        <td>
          <div className="form-group">
          <input type="text"
            className="form-control text-editable"
            value={data.post_qntt}
            name="post_qntt"
            onChange={this.updateInput}
          />
        </div>
        <div className="form-group">
          <input type="text"
            className="form-control text-editable text-editable__blue"
            value={data.cost_qntt}
            name="cost_qntt"
            onChange={this.updateInput}
          />
        </div>
        </td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td className="text-right">{fnum(data.cost_price*data.cost_qntt)}</td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt-data.cost_price*data.cost_qntt)}</td>
        <td>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              value={data.post_note}
              placeholder="Заметка"
              title="Заметка"
              name="post_note"
              onChange={this.updateInput}
            />
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSAddPostForm.js